import React from "react";
import FormStart from "../../../form/client/FormStart";
import Client from "../../../../stories/_client/Clients/Client";
import '../../../../css/overbox/ClientInformation.css';

const NewObject = props => {
    const {handleIndex} = props;

    return (
        <div className="overlayer">
            <div className="wrapOverbox">
                <div className="overbox start">
                    <FormStart object={ new Client() } handleIndex={handleIndex} />
                </div>
            </div>
        </div>
    )
}

export default NewObject;
